"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFURA_NETWORK_ENDPOINTS = exports.WALLET_URL = void 0;
const types_1 = require("../types");
exports.WALLET_URL = 'https://wallet.qubic.app';
// https://infura.io/docs/ethereum#section/Choose-a-Network
exports.INFURA_NETWORK_ENDPOINTS = {
    [types_1.Network.MAINNET]: 'mainnet',
    [types_1.Network.ROPSTEN]: 'ropsten',
    [types_1.Network.RINKEBY]: 'rinkeby',
    // [Network.KOVAN]: 'kovan',
    // [Network.GOERLI]: 'goerli',
    [types_1.Network.POLYGON]: 'polygon-mainnet',
    [types_1.Network.MUMBAI]: 'polygon-mumbai',
    // [Network.OPTIMISTIC]: 'optimism-mainnet',
    // [Network.OPTIMISTIC_KOVAN]: 'optimism-kovan',
    // [Network.ARBITRUM]: 'arbitrum-mainnet',
    // [Network.ARBITRUM_RINKEBY]: 'arbitrum-rinkeby',
    // bsc does not support
    [types_1.Network.BSC]: '',
    [types_1.Network.BSC_TESTNET]: '',
};
